import { createSlice } from "@reduxjs/toolkit";
import { DColumns } from "../../actions/data/DataDeclarations";
import { GroupTemplateRaw, ManagerUsersConfigRows } from "./createUsers";

import {
  groupTemplateLooksLike,
  userProfiles,
} from "../../actions/users/managerAsyncActions/managerAsyncActions";
import { logOut } from "../layout";

export interface ManagersUsersState {
  createManagers: {
    createSuccess: boolean;
    createLoading: boolean;
    createError: string;
    linkActions: boolean;
    usersManagersCreated: number;
  };
  managerColumns: any[];
  managerUsersConfigRows: ManagerUsersConfigRows[];
  createErrorManagerAllInarix: string[];
  createErrorManagerAllInarixShow: boolean;
  groupTemplateRaw: GroupTemplateRaw[];
  loading: boolean;
  error: string;
  tryingToCreateSomething: boolean;
  userRoles: any;
}
export const initialState: ManagersUsersState = {
  createManagers: {
    createSuccess: false,
    createLoading: false,
    createError: "",
    linkActions: false,
    usersManagersCreated: 0,
  },
  managerUsersConfigRows: [],
  managerColumns: [
    {
      field: "id",
      sortable: true,
      width: 100,
      alwaysHide: true,
    },

    {
      field: "email",
      sortable: true,
      width: 200,
      alwaysHide: false,
    },

    {
      field: "assignedSite",
      sortable: false,
      width: 240,
      alwaysHide: false,
    },
    {
      field: "role",
      sortable: false,
      width: 200,
      alwaysHide: false,
    },
    {
      field: "assignedGroups",
      sortable: false,
      width: 240,
      alwaysHide: false,
    },
    {
      field: "actions",
      sortable: false,
      width: 200,
      alwaysHide: false,
    },
  ] as DColumns[],
  createErrorManagerAllInarix: [],
  createErrorManagerAllInarixShow: false,
  groupTemplateRaw: [],
  loading: false,
  error: "",
  tryingToCreateSomething: false,
  userRoles: [],
};

export const CreateManagersSlice = createSlice({
  name: "CreateManagersReducer",
  initialState,
  reducers: {
    resetManagerRows(state) {
      return {
        ...state,
        managerUsersConfigRows: [],
        createManagers: {
          createSuccess: false,
          createLoading: false,
          createError: "",
          linkActions: false,
          usersManagersCreated: 0,
        },
      };
    },
    setTryingToCreateSomething(state, action) {
      return { ...state, tryingToCreateSomething: action.payload };
    },

    setCreateManagerCreationErrorShow(state, actions) {
      return {
        ...state,
        createErrorManagerAllInarixShow: actions.payload,
      };
    },
    setCreateManagerCreationError(state, actions) {
      return {
        ...state,
        createErrorManagerAllInarix: actions.payload,
      };
    },
    setCreateManagerValues(state, actions) {
      return {
        ...state,
        createManagers: actions.payload,
      };
    },
    setManagerColumns(state, action) {
      return {
        ...state,
        managerColumns: action.payload,
      };
    },

    setManagerUserConfigRows(state, action) {
      return { ...state, managerUsersConfigRows: action.payload };
    },

    resetCreateManagers() {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(groupTemplateLooksLike.pending, (state) => {
        state.loading = true;
      })
      .addCase(groupTemplateLooksLike.fulfilled, (state, action) => {
        state.loading = false;
        state.groupTemplateRaw = action.payload;
        state.error = "";
      })
      .addCase(groupTemplateLooksLike.rejected, (state, action: any) => {
        state.loading = false;
        state.groupTemplateRaw = [];
        state.error =
          action.payload?.response?.data?.message || action?.payload;
      });

    builder
      .addCase(userProfiles.pending, (state) => {
        state.loading = true;
      })
      .addCase(userProfiles.fulfilled, (state, action) => {
        state.userRoles = action.payload;
        state.loading = false;
        state.error = "";
      })
      .addCase(userProfiles.rejected, (state, action: any) => {
        state.loading = false;
        state.userRoles = [];
        state.error =
          action.payload?.response?.data?.message || action?.payload;
      });

    builder.addCase(logOut, () => {
      return initialState;
    });
  },
});

export const {
  resetCreateManagers,
  setManagerUserConfigRows,
  setTryingToCreateSomething,
  resetManagerRows,
  setCreateManagerCreationErrorShow,
  setCreateManagerCreationError,
  setCreateManagerValues,
  setManagerColumns,
} = CreateManagersSlice.actions;

export const CreateManagers = CreateManagersSlice.reducer;
